import React from "react";
import Top from "../../Top";
import Left from "../../Left";
// import { useNavigate } from "react-router-dom";
import { Grid } from "@mui/material";
import CreateTemplate from "./CreateTemplate";

function CreateNewTemplate() {
  // const navigate = useNavigate();

  return (
    <>
      <Top />
      <Left />
      <div className="rightContent">
        <Grid container spacing={3} className="mainHeadingLine">
          <Grid item xs={12} md={12} className="oneLineBt">
            <h1 className="panelHeading">Create New Template</h1>
          </Grid>
        </Grid>

        <Grid container spacing={3}>
          <Grid item xs={12} md={12}>
            <CreateTemplate />
          </Grid>
        </Grid>
      </div>
    </>
  );
}

export default CreateNewTemplate;
